import * as React from 'react'
import { IBadgeProps } from './interfaces'
import Icon, { AndroidFilled, AndroidOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

export const NativeAndroidBadge: React.FC<IBadgeProps> = (props) => {
    const badge = (
        <span className="icon-android">
            <AndroidFilled />
        </span>
    )

    return (
        <span className="delivery-channel-android-badge">
            {props.hideTooltip ? (
                badge
            ) : (
                <Tooltip title={props.tooltip || 'Delivery Channel: Native Android'}>{badge}</Tooltip>
            )}
        </span>
    )
}
